export const middleware = ({ request }) => {
  if (request.path) {
    return null;
  }
  return null;
};
